// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-animated-tsx": () => import("./../../../src/pages/animated.tsx" /* webpackChunkName: "component---src-pages-animated-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-interactive-tsx": () => import("./../../../src/pages/interactive.tsx" /* webpackChunkName: "component---src-pages-interactive-tsx" */),
  "component---src-pages-scatter-tsx": () => import("./../../../src/pages/scatter.tsx" /* webpackChunkName: "component---src-pages-scatter-tsx" */)
}

